import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ModalComponent from "../ModalComponent";
import Select, {Creatable} from "react-select";
import {titleize} from "../../utils";
import {connect} from "react-redux";
import {modals} from "../../ducks";
import ValidationErrors from "../forms/ValidationErrors";
import TagType from "../../propTypes/tagType";

/**
 * Bulk action modal to add/remove tags.
 */
const BulkTagModal = ({action, itemDescription, tags, onClose, onSubmit, onUnexpectedError}) => {
  const [selection, setSelection] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const Component = action === 'add' ? Creatable : Select;
  const loadingText = action === 'add' ? 'Adding...' : 'Removing...';

  const onClick = () => {
    setLoading(true);
    onSubmit(selection.map(o => o.value), action)
      .then(onClose)
      .catch(response => {
        setLoading(false);
        if (response.errors) {
          setErrors(response.errors);
        } else {
          onClose();
          onUnexpectedError();
        }
      })
  };

  return <ModalComponent
    title={titleize(`${action} Tags`)}
    buttons={[
      <button
        className='btn btn-primary'
        disabled={!selection.length || loading}
        onClick={onClick}>
        {loading ? loadingText : titleize(action)}
      </button>
    ]}>

    <ValidationErrors errors={errors}/>

    <p>
      Choose tags to {action === 'add' ? 'add to' : 'remove from'} {itemDescription}.
    </p>

    <Component
      multi
      onChange={selected => setSelection(selected)}
      options={tags.map(t => ({value: t.name, label: t.name}))}
      value={selection}
    />
  </ModalComponent>
};

BulkTagModal.propTypes = {
  action: PropTypes.oneOf(['add', 'remove']),
  itemDescription: PropTypes.string,
  onSubmit: PropTypes.func,
  tags: PropTypes.arrayOf(TagType)
};

BulkTagModal.defaultProps = {
  itemDescription: 'selected items',
  onSubmit: () => {
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(modals.actions.hide()),
  onUnexpectedError: () => dispatch(modals.actions.show('UnexpectedError'))
});

export default connect(null, mapDispatchToProps)(BulkTagModal);
